export default __webpack_public_path__ + "static/flop-app-1e82db67df7918cb091666ee0614b08a.svg";